import { Link } from 'react-router-dom';

export function Logo() {
  return (
    <Link to="/" className="flex items-center gap-1 group select-none">
      {/* Pixel grid icon */}
      <div className="relative w-8 h-8 mr-1">
        {/* 2x2 pixel grid */}
        <div className="absolute inset-0 grid grid-cols-2 grid-rows-2 gap-0.5 transform group-hover:scale-110 transition-transform duration-300">
          <div className="bg-wall-accent rounded-xs shadow-glow" />
          <div className="bg-wall-accent-secondary rounded-xs" />
          <div className="bg-wall-accent-secondary rounded-xs" />
          <div className="bg-wall-highlight rounded-xs shadow-glow" />
        </div>
      </div>

      {/* Logotype */}
      <div className="flex flex-col leading-none translate-y-[3px]">
        <span className="text-[10px] font-bold tracking-[0.3em] text-wall-muted uppercase">
          The
        </span>
        <span className="text-xl font-black tracking-tight text-gradient uppercase">Wall</span>
      </div>
    </Link>
  );
}
